import React from 'react';

import { useTranslation } from 'react-i18next';

import { type WalletConnectionStepError } from '@pkg/types';

import { ErrorMessage, ErrorTitle, StyledConnectionError } from '../../ConnectWalletSheet.style';

export interface ConnectionErrorProps {
    errorStep?: WalletConnectionStepError;
}

export function ConnectionError({ errorStep = 'error' }: ConnectionErrorProps) {
    const [translate] = useTranslation('connectWallet');

    function getErrorMessage() {
        switch (errorStep) {
            case 'tied-to-different-account': {
                return translate('sheet-connection-error-message-different');
            }
            case 'missing-external-integration': {
                return translate('sheet-connection-error-message-integration');
            }
            case 'error':
            default: {
                return translate('sheet-connection-error-message-generic');
            }
        }
    }

    return (
        <StyledConnectionError>
            <ErrorTitle>{translate('sheet-connection-error-title')}</ErrorTitle>
            <ErrorMessage>{getErrorMessage()}</ErrorMessage>
        </StyledConnectionError>
    );
}
